import Vue from 'vue';
import Vuex from 'vuex';
// 引入模块
import user from './modules/user'
import system from './modules/system'
import ins from './modules/ins'
import dict_data from './modules/dict-data'
import cargo_order from './modules/cargo-order'
import order from './modules/order'
import cargo from './modules/cargo'
import admin from './modules/admin'
import auth from './modules/auth'
Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		user,
		system,
		ins,
		dict_data,
		cargo_order,
		order,
		cargo,
		admin,
		auth
	}
})